import React from "react";
import { Typography, Box, useTheme } from "@mui/material";

const ProfileHeader = ({ userInfo }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        textAlign: "center",
        mb: 4,
        p: 3,
        borderRadius: "4px",
        backgroundColor: "#001d3d",
        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        border: "1px solid rgba(255,255,255,0.12)",
      }}
    >
      <Typography
        variant="h3"
        sx={{
          color: "#fff",
          fontWeight: 600,
          fontSize: "1.75rem",
          mb: 1,
        }}
      >
        My Profile
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "rgba(255,255,255,0.7)",
          fontSize: "0.85rem",
          maxWidth: "600px",
          mx: "auto",
        }}
      >
        Manage your personal information, address details, and home photos
      </Typography>
    </Box>
  );
};

export default ProfileHeader;